var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDirectory = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#6D6D78"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M16.25 0H1.875C.839 0 0 .84 0 1.875h0C0 2.911.84 3.75 1.875 3.75h14.792v14.583H2.917C1.306 18.333 0 17.027 0 15.417V1.883C0 .843.843 0 1.883 0h1.45M2.083 3.75L2.083 17.917M2.083 1.833L15.833 1.833",
  transform: "translate(-43 -444) translate(16 188) translate(1 238) translate(17 10) translate(9 8) translate(2.75 1.833)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M2.168 3.203l.255-.787c.064-.179.08-.376.048-.555L2.057 0 0 .34c.112 2.058.877 3.99 2.168 5.458C3.491 7.284 5.245 8.143 7.11 8.25l.223-2.434-1.53-.394c-.175-.035-.35-.017-.51.072l-.765.376c-.479-.322-.925-.716-1.324-1.163-.414-.466-.749-.967-1.036-1.504z",
  transform: "translate(-43 -444) translate(16 188) translate(1 238) translate(17 10) translate(9 8) translate(8.25 8.25)"
}))))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDirectory);
export default ForwardRef;